module.exports = {"api":{"mock":false,"host":null}};


//////////////////
// WEBPACK FOOTER
// external "{\"api\":{\"mock\":false,\"host\":null}}"
// module id = 211
// module chunks = 0